module.exports = __webpack_public_path__ + "static/media/zerenren.514c64a9.png";